<template>
  <div class="live-room">
    <!-- 左侧主区域 -->
    <div class="main-area">
      <!-- 顶部主播信息 -->
      <div class="header">
        <div class="anchor-info">
          <div @click="quzhuboye(anchorInfo.name)"  class="anchor-avatar">
            <img :src="anchorInfo.touxiang" alt="avatar" />
          </div>
          <div class="anchor-detail">
            <span class="anchor-name">{{ anchorInfo.name }}</span>
            <button class="follow-btn" :class="{ followed:$store.state.LoginStorage !== -1 ? $store.state.LoginStorage.zbid.filter(int => int == this.liveId) == this.liveId : false }" @click="toggleFollow">
              {{ $store.state.LoginStorage !== -1 ? $store.state.LoginStorage.zbid.filter(int => int == this.liveId) == this.liveId ? '已关注' : '关注' : '关注' }}
            </button>
          </div>
        </div>
        <div class="header-actions">
          <button class="close-btn" @click="closeRoom">
            <img src="../../assets/guanbi.png" alt="">
          </button>
        </div>
      </div>

      <!-- 播放器区域 -->
      <div class="player-section" ref="playerSection">
        <!-- 加载中显示占位 -->
        <div v-if="isLoading" class="loading-screen">
          <div class="loading-spinner"></div>
          <div class="loading-text">加载中...</div>
        </div>
        <!-- 直播中才显示视频 -->
        <video v-else-if="anchorInfo.statuss == 1" ref="videoPlayer" class="prism-player" :controls="false" autoplay playsinline @loadedmetadata="onVideoLoaded" @ended="onVideoEnded"></video>
        <!-- 未开播显示黑屏 -->
        <div v-else class="offline-screen">
          <div class="offline-text">未开播</div>
        </div>
        <!-- 播放器遮罩控制层：只有直播中才显示 -->
        <img v-if="anchorInfo.statuss == 1" :src="anchorInfo.fengmian" alt="封面" class="player-overlay" />
        <!-- 礼物显示 -->
        <div ref="giftDisplay" class="gift-display"></div>
        <!-- 滚动弹幕层：只有直播中且开启弹幕时才显示 -->
        <div v-if="anchorInfo.statuss == 1 && danmuEnabled" class="danmu-layer">
          <div
            v-for="danmu in danmuList"
            :key="danmu.id"
            class="danmu-item"
            :style="{
              top: danmu.top + '%',
              animationDuration: danmu.speed + 's',
              color: danmu.color
            }"
          >
            {{ danmu.text }}
          </div>
        </div>
        <!-- 点击下一个视频 -->
        <div class="next-video-btn-wrapper">
          <button class="next-video-btn" @click="switchToNextLive">
            <i class="el-icon-arrow-down"></i>
            <span>换一换</span>
          </button>
        </div>
      </div>

      <!-- 播放器控制条（视频下方）：只有直播中才显示 -->
      <div v-if="anchorInfo.statuss == 1" class="player-controls-bar">
        <button class="control-bar-btn" @click="toggleMute">
          <svg v-if="isMuted" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M11 5L6 9H2v6h4l5 4V5z"/>
            <line x1="23" y1="9" x2="17" y2="15"/>
            <line x1="17" y1="9" x2="23" y2="15"/>
          </svg>
          <svg v-else viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.5">
            <path d="M11 5L6 9H2v6h4l5 4V5z"/>
            <path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"/>
          </svg>
        </button>
        <div class="control-bar-right">
          <button class="dm-kaiguan" :class="{ active: danmuEnabled }" @click="toggleDanmu">
            <span class="dm-icon">弹</span>
            <span class="dm-status">{{ danmuEnabled ? '开' : '关' }}</span>
          </button>
          <button class="control-bar-btn" @click="shareRoom">
            <img src="../../assets/fenxiang.png" alt="">
          </button>
          <button class="control-bar-btn" @click="toggleFullscreen">
            <img src="../../assets/quanping.png" alt="">
          </button>
        </div>
      </div>

      <!-- 礼物区域：只有直播中才显示 -->
      <div v-if="anchorInfo.statuss == 1" class="gift-section">
        <div class="gift-beijing">

        </div>
        <!-- 左箭头 -->
        <button v-if="showLeftArrow" class="scroll-arrow left" @click="scrollGiftList(-1)">
          <span class="arrow-icon">&#10094;</span>
          </button>
        <div ref="giftListRef" class="gift-list" @scroll="handleGiftScroll">
          <div v-for="(gift, index) in giftList" :key="index" :class="selectedGift === index?'gift-item2':'gift-item'" @click="selectGift(index)">
            <div class="gift-icon-wrap">
              <img :src="gift.image" class="gift-icon-rose" /> 
            </div>
            <div class="gift-name">{{ gift.name }}</div>
            <div class="gift-price">
              消耗
              <span>{{ gift.number }}</span>
              甜筒
            </div>
            <button class="send-btn" :disabled="sendingGiftId === gift.id" @click.stop="sendGift(gift)">
              {{ sendingGiftId === gift.id ? '赠送中...' : '赠送' }}
            </button>
          </div>
        </div>
        <!-- 右箭头 -->
        <button v-if="showRightArrow" class="scroll-arrow right" @click="scrollGiftList(1)">
          <span class="arrow-icon">&#10095;</span>
        </button>
        <div class="gift-balance" style="margin-bottom: 25px;" @click="recharge">
          <img src="@/assets/tiantong.png" class="balance-icon" alt="甜筒" />
          <span class="balance-num">{{ userBalance }}</span>
        </div>
      </div>
    </div>

    <!-- 右侧边栏 -->
    <div class="sidebar">
      <!-- 观众列表：只有直播中才显示 -->
      <div v-if="anchorInfo.statuss == 1" class="audience-section">
        <div class="section-title">
          <span>观众 · {{ anchorInfo.anchor_number || 0 }}</span>
        </div>
        <div class="audience-list">
          <div v-for="(user, index) in audienceList" :key="index" class="audience-item">
            <img :src="user.touxiang" class="audience-avatar" alt="avatar" />
            <span class="audience-name">{{ user.anchor_name }}</span>
            <span class="audience-score">贡献度&nbsp;&nbsp;{{ user.gongxian }}</span>
          </div>
        </div>
      </div>

      <!-- 弹幕评论区：只有直播中才显示 -->
      <div v-if="anchorInfo.statuss == 1" class="chat-section">
        <div class="chat-messages" ref="chatContainer">
          <div v-for="(msg, index) in chatMessages" :key="index" class="chat-item" :class="msg.type">
            <div v-if="msg.avatar" @click="quzhuboye(msg.name)">
              <img :src="msg.avatar" class="chat-avatar" alt="avatar" />
            </div>
            <div class="chat-content">
              <p v-if="msg.name" class="chat-name">{{ msg.name }}</p>
              <p class="chat-text">{{ msg.text }}</p>
              <span v-if="msg.emoji" class="chat-emoji">{{ msg.emoji }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 未开播提示 -->
      <div v-else class="chat-offline-section">
        <div class="offline-tip">
          <i class="el-icon-warning-outline"></i>
          <span>主播暂未开播</span>
          <p>开播后将显示观众列表和弹幕</p>
        </div>
      </div>

      <!-- 底部输入区：只有直播中才显示 -->
      <div v-if="anchorInfo.statuss == 1" class="chat-input-section">
        <div class="notice-text">
          欢迎使用甜筒星球直播！你可以与其他用户实时互动、享受直播的乐趣。创作者必须年满18周岁才能开启直播。观众必须年满18周岁才能充值和赠送礼物。请务必遵守。
        </div>
        <!-- 快捷表情栏（在输入框上方，独立区域） -->
        <div class="quick-emoji-bar">
          <span class="quick-emoji-item" @click="addEmoji('😀')">😀</span>
          <span class="quick-emoji-item" @click="addEmoji('😂')">😂</span>
          <span class="quick-emoji-item" @click="addEmoji('😍')">😍</span>
          <span class="quick-emoji-item" @click="addEmoji('👍')">👍</span>
          <span class="quick-emoji-item" @click="addEmoji('🔥')">🔥</span>
          <span class="quick-emoji-item" @click="addEmoji('🎉')">🎉</span>
        </div>
        <!-- 输入区域 -->
        <div class="input-area-new">
          <!-- 表情选择面板（在输入框上方显示） -->
          <div v-if="showEmojiPicker" ref="emojiPicker" class="emoji-picker">
            <div class="emoji-grid">
              <span v-for="emoji in emojiList" :key="emoji" class="emoji-item" @click="addEmoji(emoji)">{{ emoji }}</span>
            </div>
          </div>
          <div class="input-row">
            <div class="input-wrapper">
              <input v-model="chatInput" type="text" placeholder="说点什么..." @keyup.enter="sendMessage" />
              <button ref="emojiBtn" class="emoji-btn-new" @click="toggleEmojiPicker">
                <img src="../../assets/xiaolian.png" alt="">
              </button>
            </div>
            <button class="like-btn-new" @click="sendLike">
              <img src="../../assets/dianzan.png" alt="">
            </button>
          </div>
        </div>
      </div>
      <!-- 未开播时显示提示 -->
      <div v-else class="chat-offline-notice">
        <div class="offline-notice-text">主播暂未开播，无法发送弹幕</div>
      </div>
    </div>

    <!-- 礼物动画面层 -->
    <div v-if="showGiftAnimation" class="gift-animation">
      <div class="gift-effect">🎁 {{ currentGift.name }} x{{ currentGift.count }}</div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import SVGA from 'svgaplayerweb';
import Hls from 'hls.js';

export default {
  name: 'LiveRoom',
  data() {
    return {
      //直播id
      liveId: -1,
      //视频分类
      pos:-1,
      // 视频id（用于记录播放进度）
      vid: '',
      // 播放器实例
      player: null,
      // HLS实例
      hls: null,
      // 直播地址
      liveSrc: 'artc://bo.xiangyouhulian.cn/streanm/streanm16?auth_key=1786872852-0-0-4bf6f6364a270c3799af706b5153cca6',
      // 主播信息
      anchorInfo: {},
      // 关注状态
      isFollowed: false,
      // 静音状态
      isMuted: false,
      // 观众数量
      audienceCount: 23,
      // 观众列表
      audienceList: [],
      // 弹幕消息
      chatMessages: [],
      // 聊天输入
      chatInput: '',
      // 最新加入用户
      latestJoin: 'momo',
      // 礼物列表
      giftList: [],
      // 选中礼物
      selectedGift: 0,
      // 用户余额
      userBalance: 0,
      // 礼物动画显示
      showGiftAnimation: false,
      // 当前礼物
      currentGift: { name: '', count: 1 },
      // 是否显示左箭头
      showLeftArrow: false,
      // 是否显示右箭头
      showRightArrow: true,
      // 当前登录用户信息
      userInfo: null,
      // SVGA播放器实例
      svgaPlayer: null,
      // 是否正在播放礼物动画
      isPlayingGift: false,
      // 是否全屏
      isFullscreen: false,
      // 当前正在赠送的礼物ID（防止重复点击）
      sendingGiftId: null,
      // 评论列表（从接口获取）
      commentList: [],
      // 评论显示索引
      commentIndex: 0,
      // 评论定时器
      commentTimer: null,
      // 视频保存的播放时间（秒）- 从后端getInfo接口获取
      savedPlayTime: 0,
      // 加载状态，等数据返回后再显示视频或黑屏
      isLoading: true,
      // 是否显示表情选择面板
      showEmojiPicker: false,
      // 表情列表
      emojiList: ['😀','😃','😄','😁','😆','😅','😂','🤣','😊','😇','🙂','🙃','😉','😌','😍','🥰','😘','😗','😙','😚','😋','😛','😝','😜','🤪','🤨','🧐','🤓','😎','🥸','🤩','🥳','😏','😒','😞','😔','😟','😕','🙁','😣','😖','😫','😩','🥺','😢','😭','😤','😠','😡','🤬','🤯','😳','🥵','🥶','😱','😨','😰','😥','😓','🤗','🤔','🤭','🤫','🤥','😶','😐','😑','😬','🙄','😯','😦','😧','😮','😲','🥱','😴','🤤','😪','😵','🤐','🥴','🤢','🤮','🤧','😷','🤒','🤕','🤑','🤠','😈','👿','👹','👺','🤡','💩','👻','💀','👽','👾','🤖','🎃','😺','😸','😹','😻','😼','😽','🙀','😿','😾','👋','🤚','✋','🖖','👌','✌️','🤞','🤟','🤘','🤙','👈','👉','👆','👇','☝️','👍','👎','✊','👊','🤛','🤜','👏','🙌','👐','🤲','🤝','🙏','✍️','💅','🤳','💪','👂','👃'],
      // 弹幕列表
      danmuList: [],
      // 弹幕ID计数器
      danmuIdCounter: 0,
      // 弹幕定时器
      danmuTimer: null,
      // 弹幕颜色池
      danmuColors: ['#FFFFFF', '#FF6B6B', '#4ECDC4', '#FFE66D', '#95E1D3', '#F38181', '#AA96DA', '#FCBAD3', '#FFFFD2', '#A8E6CF', '#FFD93D', '#6BCB77', '#4D96FF', '#FF6B9D', '#C9B1FF', '#FFB6B9', '#FEC8D8', '#FFDFD3', '#AED9E0', '#B8F2E6'],
      // 弹幕开关状态（默认关闭）
      danmuEnabled: false,
      // 弹幕评论索引（与评论区保持一致）
      danmuCommentIndex: 0,
    }
  },
  mounted() {
    // console.log('555',this.$route.params.id);
    // this.liveId  = this.$route.params.id;
    // this.pos = this.$route.params.pos
    // 先获取登录用户信息
    this.getUserInfo()
    // 加载主播信息，在AJAXList完成后再获取进度和初始化视频、请求评论
    this.AJAXList()
    // 添加点击空白处关闭表情面板的事件监听
    document.addEventListener('click', this.handleClickOutside)
  },
  watch: {
    /* 监听路由参数变化，id改变时刷新页面 */
    '$route.params.id'(newId, oldId) {
      if (newId !== oldId) {
        window.location.reload()
      }
    }
  },
  beforeDestroy() {
    // 页面离开时保存当前播放进度
    this.saveVideoProgress()
    // 清理HLS实例
    if (this.hls) {
      this.hls.destroy()
      this.hls = null
    }
    // 清理SVGA播放器
    if (this.svgaPlayer) {
      this.svgaPlayer.stopAnimation && this.svgaPlayer.stopAnimation()
      this.svgaPlayer.clear && this.svgaPlayer.clear()
      this.svgaPlayer = null
    }
    // 清理评论定时器
    if (this.commentTimer) {
      clearInterval(this.commentTimer)
      this.commentTimer = null
    }
    // 停止弹幕系统
    this.stopDanmu()
    // 移除点击空白处关闭表情面板的事件监听
    document.removeEventListener('click', this.handleClickOutside)
    // 移除beforeunload事件监听
    if (this._beforeUnloadHandler) {
      window.removeEventListener('beforeunload', this._beforeUnloadHandler)
    }
  },
  created() {
    // 监听页面刷新/关闭事件，保存进度到后端
    // 使用箭头函数确保 this 指向组件实例
    this._beforeUnloadHandler = () => {
      this.handleBeforeUnload()
    }
    window.addEventListener('beforeunload', this._beforeUnloadHandler)
  },
  methods: {
    //请求数据
    AJAXList(){
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/getDatas').then(res=>{
        console.log('getDatas-----------:',res.data.data);
        this.anchorInfo = {
          name: res.data.data.anchor_name,
          touxiang: res.data.data.touxiang,
          content: res.data.data.content,
          age: res.data.data.age,
          statuss: res.data.data.statuss,
          zhiboFo: res.data.data.statuss,
          anchor_number: res.data.data.anchor_number,
          anchor_video: res.data.data.anchor_video,
          fensi: res.data.data.fensi,
          fengmian: res.data.data.image,
        }
        // 设置视频id（假设后端返回vid字段，如果没有则用liveId）
        this.liveId = res.data.data.id;
        this.vid = res.data.data.id;
        this.pos = res.data.data.anchorid;
        // console.log('设置vid:', this.vid)
        // 数据加载完成，关闭加载状态
        this.isLoading = false
        // 只有直播中才获取进度、初始化视频、请求评论和贡献榜
        if (this.anchorInfo.statuss == 1) {
          // 从后端API获取进度
          this.fetchVideoProgressFromServer().then(() => {
            console.log('从后端获取进度完成，准备初始化视频, savedPlayTime:', this.savedPlayTime)
            this.$nextTick(() => {
              this.initVideoPlayer()
            })
          })
          // 请求评论和贡献榜
          this.fetchComments()
          // 弹幕默认关闭，不自动启动
        }
      }).catch(err=>{
        console.log(err);
      });

      //礼物
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/svga').then(res=>{
        this.giftList = res.data.data;
      }).catch(err=>{
        console.log(err);
      });
    },
    // 跳转到主播主页
    quzhuboye(naem){
      if(naem=='甜筒测试账号') return
      this.$router.push(`/tr/${naem}`)
    },
    // 充值 - 打开充值弹窗
    recharge() {
      this.$store.commit('setVipshow', true)
    },
    // 关注/取消关注
    toggleFollow() {
      // 检查是否登录
      if (!this.checkLogin()) {
        return
      }

      // 请求关注接口
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/zbgz', {
        yhid: this.userInfo.id,
        zbid: this.liveId,
        zbfs:this.$store.state.LoginStorage.zbid.filter(int => int == this.liveId) == this.liveId ? this.anchorInfo.fensi-- : this.anchorInfo.fensi,
        add: this.$store.state.LoginStorage.zbid.filter(int => int == this.liveId) == this.liveId ? '' : 'add'
      }).then(res => {
        console.log('关注接口返回:', res.data.data);
        if(res.data.code === 1){
          // 存储到本地浏览器
          localStorage.setItem('TTxq', JSON.stringify(res.data.data));
          // 存储到 Vuex
          this.$store.commit('LoginModification',res.data.data);
          this.$message.success(res.data.msg);
        }
        
      }).catch(err => {
        console.log('关注请求失败:', err)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    // 关闭直播间
    closeRoom() {
      this.$router.back()
    },
    // 选择礼物
    selectGift(index) {
      this.selectedGift = index
    },
    // 显示更多礼物
    showMoreGifts() {
      // TODO: 显示更多礼物弹窗
      // console.log('显示更多礼物')
    },
    // 请求评论和贡献榜（只有直播中才请求）
    fetchComments() {
      // 未开播时不请求评论和贡献榜
      if (this.anchorInfo.statuss != 1) {
        // console.log('未开播，不请求评论和贡献榜')
        return
      }
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/pinlun', {
        params: { zhuboid: this.liveId }
      }).then(res => {
        console.log('评论接口返回:', res.data)
        if (res.data.code === 1 && res.data.data) {
          // 保存评论列表
          this.commentList = res.data.data.comment_list || []
          // 保存贡献榜（取前3个）
          this.audienceList = res.data.data.user_list || []
          // 开始定时显示评论
          this.startCommentTimer()
        }
      }).catch(err => {
        console.log('评论请求失败:', err)
      })
    },
    // 开始评论定时器（每3秒显示一条）
    startCommentTimer() {
      if (this.commentList.length === 0) return

      // 立即显示第一条
      this.showNextComment()

      // 每3秒显示一条
      this.commentTimer = setInterval(() => {
        this.showNextComment()
      }, 9000)
    },
    // 显示下一条评论
    showNextComment() {
      if (this.commentIndex >= this.commentList.length) {
        this.commentIndex = 0 // 循环显示
      }

      const comment = this.commentList[this.commentIndex]
      if (comment) {
        this.chatMessages.push({
          type: 'normal',
          name: comment.yhname,
          text: comment.content,
          avatar: comment.image
        })
        this.commentIndex++
        // 滚动到底部
        this.scrollToBottom()
      }
    },
    // 初始化视频播放器（支持m3u8）
    initVideoPlayer() {
      const video = this.$refs.videoPlayer
      if (!video) return

      const videoUrl = this.anchorInfo.anchor_video
      if (!videoUrl) return

      // 判断是否为m3u8格式
      if (videoUrl.includes('.m3u8')) {
        // 使用HLS.js播放m3u8
        if (Hls.isSupported()) {
          this.hls = new Hls()
          this.hls.loadSource(videoUrl)
          this.hls.attachMedia(video)
          this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
            // console.log('HLS manifest parsed, ready to play')
            console.log('准备设置播放时间, savedPlayTime:', this.savedPlayTime)
            // 如果有保存的进度，跳转到对应时间
            if (this.savedPlayTime > 0) {
              video.currentTime = this.savedPlayTime
              console.log('已设置播放时间到:', this.savedPlayTime)
            } else {
              console.log('savedPlayTime为0，不设置播放时间')
            }
            this.tryAutoplay()
          })
        } else if (video.canPlayType('application/vnd.apple.mpegurl')) {
          // Safari原生支持HLS
          video.src = videoUrl
          video.addEventListener('loadedmetadata', () => {
            console.log('Safari loadedmetadata, savedPlayTime:', this.savedPlayTime)
            if (this.savedPlayTime > 0) {
              video.currentTime = this.savedPlayTime
              console.log('Safari已设置播放时间到:', this.savedPlayTime)
            }
            this.tryAutoplay()
          })
        }
      } else {
        // 普通视频格式
        video.src = videoUrl
        video.addEventListener('loadedmetadata', () => {
          // console.log('普通视频 loadedmetadata, savedPlayTime:', this.savedPlayTime)
          if (this.savedPlayTime > 0) {
            video.currentTime = this.savedPlayTime
            // console.log('普通视频已设置播放时间到:', this.savedPlayTime)
          }
          this.tryAutoplay()
        })
      }
    },

    // 从后端API获取视频进度
    fetchVideoProgressFromServer() {
      return new Promise((resolve) => {
        axios.get('https://ttxq.xiangyouhulian.cn/api/index/getInfo', {
          params: { vid: this.vid, pos: this.pos }
        }).then(res => {
          // console.log('获取播放进度接口返回:', res.data)
          // 支持 code 为 1 或 200 都表示成功
          if ((res.data.code === 1 || res.data.code === 200) && res.data.data) {
            // 保存获取到的播放时间
            this.savedPlayTime = parseFloat(res.data.data.start_second) || 0
            console.log('从后端获取到播放时间:', this.savedPlayTime, '秒')
          } else {
            console.log('获取进度失败或没有数据:', res.data)
            this.savedPlayTime = 0
          }
          resolve()
        }).catch(err => {
          console.log('获取播放进度失败:', err)
          this.savedPlayTime = 0
          resolve()
        })
      })
    },

    // 保存视频播放进度到后端（路由跳转、页面刷新、页面关闭时调用）
    saveVideoProgress() {
      const video = this.$refs.videoPlayer
      if (!this.vid || !video) return

      const currentSec = Math.floor(video.currentTime || 0)
      if (currentSec <= 0) return

      // 请求后端API保存进度
      axios.post('https://ttxq.xiangyouhulian.cn/api/index/saveAdd10Sec', {
        vid: this.vid,
        sec: currentSec,
        pos: this.pos
      }).then(res => {
        console.log('保存播放进度成功:', res.data)
      }).catch(err => {
        console.log('保存播放进度失败:', err)
      })
    },
    // 页面刷新/关闭前保存进度到后端（使用sendBeacon确保发送成功）
    handleBeforeUnload() {
      const video = this.$refs.videoPlayer
      if (!this.vid || !video) return
      const currentSec = Math.floor(video.currentTime || 0)
      if (currentSec > 0) {
        // 使用 URLSearchParams 格式（form-data），后端更容易解析
        const formData = new URLSearchParams()
        formData.append('vid', this.vid)
        formData.append('sec', currentSec)
        formData.append('pos', this.pos)
        navigator.sendBeacon('https://ttxq.xiangyouhulian.cn/api/index/saveAdd10Sec', formData)
      }
    },

    // 尝试自动播放视频（带声音）
    tryAutoplay() {
      const video = this.$refs.videoPlayer
      if (!video) return

      // 先尝试有声播放
      video.muted = false
      video.play().then(() => {
        console.log('自动播放成功（有声）')
        this.isMuted = false
      }).catch(err => {
        console.log('有声自动播放被阻止，尝试静音播放:', err)
        // 有声播放失败，尝试静音自动播放
        video.muted = true
        video.play().then(() => {
          console.log('静音自动播放成功')
          this.isMuted = true
          // 3秒后尝试恢复声音
          setTimeout(() => {
            video.muted = false
            this.isMuted = false
            console.log('已恢复声音')
          }, 3000)
        }).catch(err2 => {
          console.log('自动播放完全失败:', err2)
        })
      })
    },
    // 切换静音
    toggleMute() {
      const video = this.$refs.videoPlayer
      if (video) {
        this.isMuted = !this.isMuted
        video.muted = this.isMuted
        // 如果取消静音，尝试播放
        if (!this.isMuted && video.paused) {
          video.play().catch(err => {
            console.log('播放失败:', err)
          })
        }
      }
    },
    // 视频播放完成后自动执行回调
    onVideoEnded() {
       if (!this.vid) return
      this.$router.push('/');
    },
    // 视频加载完成后判断比例
    onVideoLoaded() {
      const video = this.$refs.videoPlayer
      if (!video) return
      
      const width = video.videoWidth
      const height = video.videoHeight
      
      // 判断是否为竖屏视频（高度大于宽度）
      if (height > width) {
        video.classList.add('portrait')
      } else {
        video.classList.remove('portrait')
      }
    },
    // 切换全屏
    toggleFullscreen() {
      const playerSection = this.$refs.playerSection
      if (!playerSection) return

      if (!this.isFullscreen) {
        // 进入全屏
        if (playerSection.requestFullscreen) {
          playerSection.requestFullscreen()
        } else if (playerSection.webkitRequestFullscreen) {
          playerSection.webkitRequestFullscreen()
        } else if (playerSection.mozRequestFullScreen) {
          playerSection.mozRequestFullScreen()
        } else if (playerSection.msRequestFullscreen) {
          playerSection.msRequestFullscreen()
        }
        this.isFullscreen = true
      } else {
        // 退出全屏
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
        this.isFullscreen = false
      }
    },
    // 获取登录用户信息
    getUserInfo() {
      // 从localStorage获取用户信息
      const userInfoStr = localStorage.getItem('TTxq')
      if (userInfoStr) {
        try {
          this.userInfo = JSON.parse(userInfoStr)
          // 更新用户余额显示
          this.userBalance = this.userInfo.coin || 0
        } catch (e) {
          console.log('解析用户信息失败:', e)
          this.userInfo = null
        }
      }
    },
    // 检查是否登录
    checkLogin() {
      if (!this.userInfo || !this.userInfo.id) {
        alert('请先登录后再赠送礼物')
        // 可以在这里跳转到登录页或打开登录弹窗
        // this.$router.push('/login')
        return false
      }
      return true
    },
    // 播放SVGA礼物动画
    playGiftAnimation(gift) {
      // 如果正在播放，先停止并清理
      if (this.isPlayingGift && this.svgaPlayer) {
        this.svgaPlayer.stopAnimation && this.svgaPlayer.stopAnimation()
        this.svgaPlayer.clear && this.svgaPlayer.clear()
        this.svgaPlayer = null
        // 清空容器
        const container = this.$refs.giftDisplay
        if (container) {
          container.innerHTML = ''
        }
      }

      // 如果没有svga动画地址，不播放
      if (!gift.svga) {
        console.log('该礼物没有SVGA动画')
        return
      }

      this.isPlayingGift = true

      // 创建canvas元素
      const container = this.$refs.giftDisplay
      if (!container) {
        console.log('礼物显示容器不存在')
        this.isPlayingGift = false
        return
      }

      // 清空容器
      container.innerHTML = ''

      // 创建canvas - 设置具体宽高避免显示不全
      const canvas = document.createElement('canvas')
      canvas.width = 600
      canvas.height = 600
      canvas.style.width = '100%'
      canvas.style.height = '100%'
      container.appendChild(canvas)

      // 初始化SVGA播放器
      this.svgaPlayer = new SVGA.Player(canvas)
      const parser = new SVGA.Parser(canvas)

      // 使用代理解决跨域 - 将阿里云OSS地址转为本地代理地址
      let svgaUrl = gift.svga
      if (svgaUrl && svgaUrl.includes('momovideo.oss-cn-beijing.aliyuncs.com')) {
        svgaUrl = svgaUrl.replace('https://momovideo.oss-cn-beijing.aliyuncs.com', '/svga-file')
      }
      console.log('代理SVGA地址:', svgaUrl)

      // 加载并播放SVGA
      parser.load(svgaUrl, (videoItem) => {
        console.log('SVGA加载成功')
        this.svgaPlayer.setVideoItem(videoItem)
        // 设置只播放一次，不循环
        this.svgaPlayer.loops = 1
        this.svgaPlayer.startAnimation()

        // 动画结束回调
        this.svgaPlayer.onFinished(() => {
          this.isPlayingGift = false
          // 清理
          if (container) {
            container.innerHTML = ''
          }
          this.svgaPlayer = null
        })
      }, (error) => {
        console.log('SVGA加载失败:', error)
        this.isPlayingGift = false
      })
    },
    // 发送礼物
    sendGift(gift) {
      // 防止重复点击
      if (this.sendingGiftId) return
      this.sendingGiftId = gift.id

      // 1. 检查是否登录
      if (!this.checkLogin()) {
        this.sendingGiftId = null
        return
      }
      //判断是否开启了未成年人模式
      if(this.$store.state.teenagerMode==true){
        this.sendingGiftId = null
        this.$message({
          message: '未成年人模式已开启，无法赠送礼物',
          type: 'warning'
        });
        return
      }

      // 2. 检查用户余额
      const userCoin = parseFloat(this.userInfo.coin) || 0
      const giftPrice = parseFloat(gift.number) || 0

      console.log('当前用户coin:', userCoin)
      console.log('礼物价格:', giftPrice)

      // 3. 判断余额是否足够
      if (userCoin < giftPrice) {
        this.sendingGiftId = null
        alert('余额不足，请先充值')
        return
      }

      // 4. 扣除本地余额
      const newCoin = userCoin - giftPrice
      this.userInfo.coin = newCoin
      this.userBalance = newCoin

      axios.get('https://ttxq.xiangyouhulian.cn/api/index/sliwu',{params:{
          liwunum: gift.number,
          liwuid: gift.id,
          yhid: this.userInfo.id,
          zhuboid: this.liveId
      }}).then(res=>{
          if(res.data.code === 1){
            // 更新本地存储
            localStorage.setItem('TTxq', JSON.stringify(res.data.data.updated_user))
            this.$store.commit('LoginModification', res.data.data.updated_user);
          } else {
            this.$message.error(res.data.msg || '送礼失败')
          }
      }).catch(err=>{
          console.log('送礼请求失败:', err)
          this.$message.error('网络错误，请稍后重试')
      })

      // 5. 显示送出成功提示
      this.$message({
        message: `送出 ${gift.name} 成功！剩余 ${newCoin} 甜筒币`,
        type: 'success'
      })

      // 6. 添加到右侧评论区显示送礼信息
      this.chatMessages.push({
        type: 'gift',
        name: this.userInfo.nickname || this.userInfo.name || '我',
        text: `送出了 ${gift.name} x1`,
        avatar: this.userInfo.touxiang || this.userInfo.image || 'https://via.placeholder.com/24'
      })
      // 滚动到底部
      this.scrollToBottom()

      // 7. 播放礼物动画
      this.playGiftAnimation(gift)

      // 8. 动画播放完后恢复按钮（3秒后）
      setTimeout(() => {
        this.sendingGiftId = null
      }, 3000)
    },
    // 发送消息
    sendMessage() {
      if (!this.chatInput.trim()) return

      // 检查是否登录
      if (!this.checkLogin()) return

      const content = this.chatInput.trim()

      // 请求发送评论接口
      axios.get('https://ttxq.xiangyouhulian.cn/api/index/publishs', {
        params: {
          yhname: this.userInfo.username,
          content: content,
          zhuboid: this.liveId
        }
      }).then(res => {
        console.log('发送评论返回:', res.data)
        if (res.data.code === 1 || res.data.code === 200) {
          // 添加到评论区
          this.chatMessages.push({
            type: 'normal',
            name: this.userInfo.nickname,
            text: content,
            avatar: this.userInfo.image
          })
          // 滚动到底部
          this.scrollToBottom()
          this.chatInput = ''
        } else {
          this.$message.error(res.data.msg || '发送失败')
        }
      }).catch(err => {
        console.log('发送评论失败:', err)
        this.$message.error('网络错误，请稍后重试')
      })
    },
    // 滚动评论区到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const container = this.$refs.chatContainer
        if (container) {
          container.scrollTop = container.scrollHeight
        }
      })
    },
    // 滚动礼物列表
    scrollGiftList(direction) {
      const list = this.$refs.giftListRef
      if (!list) return
      const scrollAmount = 200 // 每次滚动距离
      list.scrollBy({
        left: direction * scrollAmount,
        behavior: 'smooth'
      })
    },
    // 切换表情选择面板
    toggleEmojiPicker(event) {
      event.stopPropagation()
      this.showEmojiPicker = !this.showEmojiPicker
    },
    // 点击空白处关闭表情面板
    handleClickOutside(event) {
      const emojiPicker = this.$refs.emojiPicker
      const emojiBtn = this.$refs.emojiBtn
      if (this.showEmojiPicker && emojiPicker && !emojiPicker.contains(event.target) && emojiBtn && !emojiBtn.contains(event.target)) {
        this.showEmojiPicker = false
      }
    },
    // 添加表情到输入框
    addEmoji(emoji) {
      this.chatInput += emoji
    },
    // 发送点赞
    sendLike() {
      // 检查是否登录
      if (!this.checkLogin()) return

      // 添加到评论区显示点赞
      this.chatMessages.push({
        type: 'like',
        name: this.userInfo.nickname,
        text: '点了个赞 ❤️',
        avatar: this.userInfo.image
      })
      // 滚动到底部
      this.scrollToBottom()
    },
    // 分享直播间
    shareRoom() {
      // 复制直播间链接到剪贴板
      const shareUrl = window.location.href
      if (navigator.clipboard) {
        navigator.clipboard.writeText(shareUrl).then(() => {
          this.$message.success('链接已复制到剪贴板')
        }).catch(() => {
          this.$message.info('分享链接: ' + shareUrl)
        })
      } else {
        // 降级方案
        const input = document.createElement('input')
        input.value = shareUrl
        document.body.appendChild(input)
        input.select()
        document.execCommand('copy')
        document.body.removeChild(input)
        this.$message.success('链接已复制到剪贴板')
      }
    },
    // 处理礼物列表滚动事件
    handleGiftScroll() {
      const list = this.$refs.giftListRef
      if (!list) return
      // 判断是否显示左箭头
      this.showLeftArrow = list.scrollLeft > 0
      // 判断是否显示右箭头
      this.showRightArrow = list.scrollLeft < list.scrollWidth - list.clientWidth - 5
    },
    // 切换到下一个直播
    switchToNextLive() {
      // 先保存当前视频进度
      this.saveVideoProgress();
      // 清空评论相关数据
      this.chatMessages = [];
      this.commentList = [];
      this.commentIndex = 0;
      this.audienceList = [];
      // 清理评论定时器
      if (this.commentTimer) {
        clearInterval(this.commentTimer);
        this.commentTimer = null;
      }
      // 停止弹幕系统
      this.stopDanmu();
      // 重置加载状态
      this.isLoading = true;
      this.AJAXList();
    },
    // 切换弹幕开关
    toggleDanmu() {
      console.log('切换弹幕开关，当前状态:', this.danmuEnabled)
      this.danmuEnabled = !this.danmuEnabled
      console.log('切换后状态:', this.danmuEnabled)
      if (this.danmuEnabled) {
        // 立即显示一条弹幕
        this.sendDanmu()
        // 再启动定时器
        this.startDanmu()
      } else {
        this.stopDanmu()
      }
    },
    // 启动弹幕系统
    startDanmu() {
      // 清理旧定时器
      if (this.danmuTimer) {
        clearInterval(this.danmuTimer)
      }
      // 每10秒发送一条弹幕（与评论区顺序一致）
      this.danmuTimer = setInterval(() => {
        this.sendDanmu()
      }, 10000)
    },
    // 停止弹幕系统
    stopDanmu() {
      if (this.danmuTimer) {
        clearInterval(this.danmuTimer)
        this.danmuTimer = null
      }
      this.danmuList = []
    },
    // 发送弹幕（与评论区顺序保持一致）
    sendDanmu() {
      console.log('发送弹幕，danmuList长度:', this.danmuList.length)
      // 从评论列表中按顺序取一条
      if (this.commentList.length === 0) {
        // 如果评论列表为空，使用默认弹幕
        const defaultDanmu = {
          id: this.danmuIdCounter++,
          text: '欢迎来到直播间！',
          top: Math.random() * 40 + 5, // 限制在上半区域 5%-45%
          speed: Math.random() * 5 + 18,
          color: this.danmuColors[Math.floor(Math.random() * this.danmuColors.length)]
        }
        this.danmuList.push(defaultDanmu)
        console.log('添加默认弹幕:', defaultDanmu)
        setTimeout(() => {
          const index = this.danmuList.findIndex(d => d.id === defaultDanmu.id)
          if (index > -1) {
            this.danmuList.splice(index, 1)
          }
        }, defaultDanmu.speed * 1000)
        return
      }

      // 循环使用评论列表，与评论区保持一致
      if (this.danmuCommentIndex >= this.commentList.length) {
        this.danmuCommentIndex = 0
      }

      const comment = this.commentList[this.danmuCommentIndex]
      if (!comment) return

      const danmu = {
        id: this.danmuIdCounter++,
        text: `${comment.yhname}：${comment.content || '666'}`,
        top: Math.random() * 40 + 5, // 限制在上半区域 5%-45%
        speed: Math.random() * 5 + 18, // 随机速度 18-23秒
        color: this.danmuColors[Math.floor(Math.random() * this.danmuColors.length)]
      }
      this.danmuList.push(danmu)

      // 递增索引
      this.danmuCommentIndex++

      // 动画结束后移除
      setTimeout(() => {
        const index = this.danmuList.findIndex(d => d.id === danmu.id)
        if (index > -1) {
          this.danmuList.splice(index, 1)
        }
      }, danmu.speed * 1000)
    }
  }
}
</script>

<style scoped lang="scss">
// 直播间主容器
.live-room {
  display: flex;
  width: 100%;
  height: 100vh;
  background: linear-gradient(135deg, #ffffff 0%, #ffffff 100%);
  overflow: hidden;
}

// 左侧主区域
.main-area {
  width: 75.5%;
  height: 93.2vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 16px 16px;
  // 给右侧边栏留空间（20%宽度 + 间距）
  // padding-right: calc(20% + 32px);
  min-width: 0;
  background-color: #F5F3FA;
  margin-top: 1%;
  border-radius: 10px;
}

// 顶部头部
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 16px;
  // background: rgba(255, 255, 255, 0.6);
  border-radius: 24px;
  backdrop-filter: blur(10px);
}

// 主播信息
.anchor-info {
  min-width: 150px;
  display: flex;
  align-items: center;
  padding: 4px 4px;
  border-radius: 30px;
  background-color: rgba(0, 0, 0, 0.693);
  gap: 12px;
}

.anchor-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #fff;
  overflow: hidden;
  cursor: pointer;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.anchor-detail {
  align-items: center;
}

.anchor-name {
  font-size: 17px;
  color: #fffefe;
}

.follow-btn {
  line-height: 29px;
  padding: 6px 20px;
  background: #FF2F86;
  border: none;
  border-radius: 40px;
  color: #fff;
  font-size: 15px;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-left: 12px;
  &:hover {
    opacity: 0.9;
  }

  &.followed {
    background: #ccc;
  }
}

// 头部操作
.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.close-btn {
  width: 35px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(253, 253, 253, 0);
  background-color: #ffffff00;
  cursor: pointer;
  color: #666;
  transition: all 0.3s ease;
  img{
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

// 播放器区域
.player-section {
  position: relative;
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  // 直播中固定比例，未开播时自适应高度
  aspect-ratio: 16 / 8;
  flex: 1;
  min-height: 0;

  // 播放器容器
  .prism-player {
    width: 100%;
    height: 100%;
    object-fit: cover;
    position: relative;
    z-index: 1;
    background-color: #000;
  }
  
  // 加载中屏幕
  .loading-screen {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
  }
  
  // 加载动画
  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255, 255, 255, 0.1);
    border-top-color: #9B7ED9;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
  }
  
  // 加载文字
  .loading-text {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
    letter-spacing: 2px;
  }
  
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  
  // 未开播黑屏 - 高级渐变背景（类似虎牙斗鱼）
  .offline-screen {
    width: 100%;
    height: 100%;
    background: 
      radial-gradient(ellipse at 20% 30%, rgba(88, 101, 242, 0.15) 0%, transparent 50%),
      radial-gradient(ellipse at 80% 70%, rgba(235, 69, 95, 0.1) 0%, transparent 50%),
      linear-gradient(180deg, #0f1419 0%, #1a1f2e 50%, #0f1419 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 1;
    overflow: hidden;
    
    // 网格纹理
    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-image: 
        linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px);
      background-size: 50px 50px;
      pointer-events: none;
    }
    
    // 动态光晕
    &::after {
      content: '';
      position: absolute;
      width: 600px;
      height: 600px;
      background: radial-gradient(circle, rgba(88, 101, 242, 0.2) 0%, transparent 60%);
      border-radius: 50%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      animation: breathe 4s ease-in-out infinite;
    }
  }
  
  // 未开播文字 - 虎牙斗鱼风格
  .offline-text {
    font-size: 20px;
    font-weight: 600;
    color: rgba(255, 255, 255, 0.9);
    padding: 16px 40px;
    background: rgba(30, 35, 50, 0.8);
    backdrop-filter: blur(10px);
    border-radius: 12px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    box-shadow: 
      0 4px 20px rgba(0, 0, 0, 0.4),
      inset 0 1px 0 rgba(255, 255, 255, 0.05);
    letter-spacing: 8px;
    position: relative;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: 12px;
    
    // 灰色圆点（未开播状态）
    &::before {
      content: '';
      width: 8px;
      height: 8px;
      background: #6b7280;
      border-radius: 50%;
      box-shadow: 0 0 8px rgba(107, 114, 128, 0.5);
      animation: pulse-dot 2s ease-in-out infinite;
    }
  }
  
  // 动画定义
  @keyframes breathe {
    0%, 100% {
      transform: translate(-50%, -50%) scale(1);
      opacity: 0.3;
    }
    50% {
      transform: translate(-50%, -50%) scale(1.1);
      opacity: 0.5;
    }
  }
  
  @keyframes pulse-dot {
    0%, 100% {
      opacity: 0.6;
      transform: scale(1);
    }
    50% {
      opacity: 1;
      transform: scale(1.2);
    }
  }
  
  // 竖屏视频样式
  .prism-player.portrait {
    object-fit: contain;
  }
}

// 播放器底部控制条（在视频下方）
.player-controls-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 16px;
  background: transparent;
  z-index: 50;
  margin-bottom: 8px;

  .control-bar-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  // 弹幕开关按钮
  .dm-kaiguan {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 4px 10px;
    background: rgba(200, 200, 200, 0.5);
    border: 1px solid rgba(150, 150, 150, 0.5);
    border-radius: 12px;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 12px;
    color: #666;

    .dm-icon {
      font-weight: bold;
      font-size: 13px;
    }

    .dm-status {
      font-size: 11px;
    }

    &:hover {
      background: rgba(180, 180, 180, 0.6);
    }

    // 开启状态
    &.active {
      background: rgba(155, 126, 217, 0.9);
      border-color: #9B7ED9;
      color: #fff;

      &:hover {
        background: rgba(139, 92, 246, 1);
      }
    }
  }

  .control-bar-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: none;
    cursor: pointer;
    color: #999;
    transition: all 0.2s ease;

    &:hover {
      color: #666;
    }

    img {
      width: 22px;
      height: 22px;
    }
    svg {
      width: 27px;
      height: 27px;
      color: #1f064a;
    }
  }
}

// 旧版播放器底部控制按钮（保留兼容）
.player-controls-bottom {
  position: absolute;
  bottom: 16px;
  right: 16px;
  display: flex;
  gap: 8px;
  z-index: 50;

  .control-btn {
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 8px;
    cursor: pointer;
    color: #fff;
    font-size: 16px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(0, 0, 0, 0.7);
      transform: scale(1.1);
    }

    i {
      font-size: 18px;
    }
  }
}

// 礼物显示区域（在播放器中间）
.gift-display {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background-color: #333;
  height:600px;
  width:600px;
  z-index: 100;
  pointer-events: none;
}

// 弹幕层
.danmu-layer {
  position: absolute;
  top: 10px; // 距离顶部10px，让弹幕靠上显示
  left: 0;
  right: 0;
  bottom: 0;
  overflow: visible;
  pointer-events: none;
  z-index: 200;
}

// 弹幕项
.danmu-item {
  position: absolute;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 500;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.8);
  animation-name: danmuMove;
  animation-timing-function: linear;
  animation-fill-mode: forwards;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.3);
  right: 0;
  margin-top: -30px; // 向上偏移30px，让弹幕更靠上
}

// 弹幕从右往左移动动画
@keyframes danmuMove {
  from {
    transform: translateX(100%);
  }
  to {
    transform: translateX(-100vw);
  }
}

// 播放器遮罩层
.player-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  filter: blur(50px);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.overlay-top {
  pointer-events: auto;
}

.overlay-center {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  padding: 0 16px;
  pointer-events: auto;
}

.nav-btn {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
}

.overlay-bottom {
  pointer-events: auto;
}

.player-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.control-btn {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.4);
  }
}

.control-right {
  display: flex;
  gap: 8px;
}

// 礼物区域
.gift-section {
  display: flex;
  align-items: flex-end;
  padding: 0px 20px;
  height: 130px;
  gap: 12px;
  position: relative;
  overflow: visible;
  margin-top: 20px;
}
.gift-beijing{
  width: 100%;
  height: 126px;
  position: absolute;
  bottom: 0;
  left: 0;
  border-radius: 8px;
  background: #D9D5E5;
}
.gift-list {
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  scrollbar-width: none;
  -ms-overflow-style: none;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}
.gift-item2{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 14px;
  border-radius: 12px;
  cursor: pointer;
  // transition: all 0.3s ease;
  min-width: 60px;
  position: relative;
  flex-shrink: 0;
  margin-bottom: 10px;
  background: rgb(240 229 255 / 24%);
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 20px rgba(155, 126, 217, 0.25);
    border-radius: 14px;
    z-index: 10;
    .send-btn {
      display: block;
    }
}
.gift-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 5px 14px;
  border-radius: 12px;
  cursor: pointer;
  min-width: 60px;
  position: relative;
  flex-shrink: 0;
  margin-top: 16px;
  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &.more {
    background: transparent;
    border: 1px dashed #9B8DC7;
    padding: 10px 12px;
    justify-content: center;
    min-height: 65px;

    &:hover {
      background: rgba(255, 255, 255, 0.3);
    }
  }
}

.gift-icon-wrap {
  margin-bottom: 4px;
}

.gift-icon-rose {
  height: 46px;
  position: relative;
}

.gift-name {
  font-size:14px;
  color: #4B3B73;
  margin-bottom: 2px;
}

.gift-price {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  color: #9B8DC7;
  span {
    font-size: 10px;
    color: #ff491b;
  }
  i {
    font-size: 9px;
    color: #E6A23C;
  }
}

.send-btn {
  display: none;
  margin-top: 6px;
  padding: 4px 16px;
  background: #9B7ED9;
  color: #fff;
  font-size: 12px;
  font-weight: 500;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #8B5CF6;
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
  }
}

.more-box {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #9B8DC7;
  border-radius: 4px;
  margin-bottom: 4px;

  i {
    font-size: 12px;
    color: #7B5FB9;
  }
}

.gift-balance {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  padding: 10px 10px;
  background: rgba(255, 255, 255, 0.5);
  border-radius: 10px;
  min-width: 50px;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.8);
    transform: scale(1.05);
  }

  .balance-icon {
    height: 35px;
    object-fit: contain;
  }

  .balance-num {
    font-size: 12px;
    color: #4B3B73;
  }
}

// 礼物列表滚动箭头
.scroll-arrow {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #9B7ED9 0%, #7B5FB9 100%);
  border: none;
  border-radius: 50%;
  color: #fff;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(155, 126, 217, 0.4);
  z-index: 20;
  align-self: center; // 垂直居中
  margin-bottom: -15px; // 与礼物项底部对齐

  .arrow-icon {
    font-size: 14px;
    font-weight: bold;
    line-height: 1;
  }

  &:hover {
    transform: scale(1.1);
    box-shadow: 0 6px 16px rgba(155, 126, 217, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }

  &.left {
    margin-right: 8px;
  }

  &.right {
    margin-left: 8px;
  }
}

// 右侧边栏
.sidebar {
  // 宽度按比例自适应，最小260px
  width: 16%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  padding: 16px;
  background: #F3EFFF;
  border-left: 1px solid rgba(255, 255, 255, 0.5);
  height: 93.2vh;
  position: fixed;
  right: 0.5%;
  top: 1.6%;
  border-radius: 12px;
  overflow: hidden;
}

// 观众区域
.audience-section {
  margin-bottom: 16px;
}

.section-title {
  font-size: 16px;
  font-weight: 500;
  color: #333;
  margin-bottom: 12px;
}

.audience-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.audience-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 0px;
  // background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;
}

.audience-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.audience-name {
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.audience-score {
  font-size: 13px;
  color: #8a3ffc;
}

// 聊天区域
.chat-section {
  flex: 1;
  overflow: hidden;
  margin-bottom: 16px;
}

.chat-messages {
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-right: 4px;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
    border-radius: 2px;
  }
}

.chat-item {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 8px 0%;
  // background: rgba(255, 255, 255, 0.6);
  border-radius: 8px;

  &.gift {
   // background: linear-gradient(135deg, rgba(255, 215, 0, 0.2) 0%, rgba(255, 215, 0, 0.1) 100%);

    .chat-text {
      color: #ff0000;
      font-weight: bold;
      font-style: italic;
    }
  }

  // &.like {
  //   background: linear-gradient(135deg, rgba(255, 107, 157, 0.2) 0%, rgba(255, 107, 157, 0.1) 100%);
  // }
}

.chat-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.chat-content {
  gap: 4px;
  font-size: 13px;
  line-height: 20px;
}

.chat-name {
  color: #8a3ffc;
  font-weight: 400;
}

.chat-text {
  color: #333;
   font-weight: 500;
}

.chat-emoji {
  font-size: 16px;
}

// 聊天输入区
.chat-input-section {
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
}

.notice-text {
  font-size: 13px;
  color: #999;
  line-height: 1.5;
  padding: 8px;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 8px;
}

.join-notice {
  display: flex;
  flex-direction: column;
  gap: 4px;
  font-size: 12px;
  color: #666;

  span {
    color: #8a3ffc;
  }
}

.emoji-list {
  display: flex;
  gap: 4px;
  font-size: 16px;
}

.input-area {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 24px;

  input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 13px;
    color: #333;
    outline: none;

    &::placeholder {
      color: #999;
    }
  }
}

.send-msg-btn {
  padding: 6px 16px;
  background: linear-gradient(135deg, #9B7ED9 0%, #7B5FB9 100%);
  border: none;
  border-radius: 16px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    opacity: 0.9;
    transform: scale(1.05);
  }

  &:active {
    transform: scale(0.95);
  }
}

// 新输入区域样式
.input-area-new {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 5px 0px;
  border-radius: 16px;
  background: transparent;
  border: none;
}

// 快捷表情栏（独立在输入框上方）
.quick-emoji-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 12px;
  margin-bottom: 8px;
}

.quick-emoji-item {
  font-size: 22px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    transform: scale(1.2);
  }
}

// 输入行
.input-row {
  display: flex;
  align-items: center;
  gap: 8px;
}

// 输入框包装器
.input-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  background: #fff;
  border: 1px solid rgba(155, 126, 217, 0.15);
  border-radius: 20px;
  padding: 0 12px;
  height: 44px;

  input {
    flex: 1;
    border: none;
    background: transparent;
    font-size: 14px;
    color: #333;
    outline: none;
    padding: 0;
    min-width: 0;

    &::placeholder {
      color: #999;
    }
  }
}

.input-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
}

.emoji-btn {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(155, 126, 217, 0.15);
  border-radius: 50%;
  cursor: pointer;
  color: #666;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;

  &:hover {
    background: rgba(155, 126, 217, 0.1);
    color: #9B7ED9;
  }

  svg {
    width: 18px;
    height: 18px;
  }
}

// 新版表情按钮（在输入框内部）
.emoji-btn-new {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  color: #999;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;
  margin-left: 4px;

  &:hover {
    color: #666;
  }

  img {
    width: 25px;
    height: 25px;
  }
}

.like-btn {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ff6b9d;
  border: none;
  border-radius: 50%;
  cursor: pointer;
  color: #fff;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;

  &:hover {
    transform: scale(1.05);
    box-shadow: 0 4px 12px rgba(255, 107, 157, 0.4);
  }

  &:active {
    transform: scale(0.95);
  }

  svg {
    width: 16px;
    height: 16px;
  }
}

// 新版爱心按钮（圆角方形带边框）
.like-btn-new {
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border: 1px solid rgba(255, 239, 244, 0.3);
  border-radius: 50px;
  cursor: pointer;
  color: #ff2e74;
  transition: all 0.2s ease;
  flex-shrink: 0;
  padding: 0;

  &:hover {
    background: rgba(255, 107, 157, 0.05);
    border-color: rgba(255, 107, 157, 0.5);
  }

  &:active {
    transform: scale(0.95);
  }

  img {
    width: 22px;
    height: 22px;
  }
}

// 表情选择面板（在输入框上方显示）
.emoji-picker {
  position: absolute;
  bottom: 100%;
  left: 0;
  right: 0;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15);
  padding: 12px;
  margin-bottom: -96px;
  max-height: 200px;
  padding: 5px 5px;
  overflow-y: auto;
  z-index: 100;
}
// .emoji-picker::-webkit-scrollbar {
//   display: none;
// }
.emoji-picker::-webkit-scrollbar {
  width: 6px;
  padding: 2px;
}
.emoji-picker::-webkit-scrollbar-track {
  background:#eee;
}
.emoji-picker::-webkit-scrollbar-thumb {
  background:#999;
  border-radius:3px;
}
.emoji-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 8px;
}

.emoji-item {
  font-size: 20px;
  text-align: center;
  cursor: pointer;
  padding: 4px;
  border-radius: 4px;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background: rgba(155, 126, 217, 0.1);
    transform: scale(1.2);
  }
}

// 未开播时右侧提示
.chat-offline-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  .offline-tip {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    padding: 32px;
    text-align: center;

    i {
      font-size: 48px;
      color: #9B8DC7;
    }

    span {
      font-size: 16px;
      font-weight: 500;
      color: #666;
    }

    p {
      font-size: 13px;
      color: #999;
    }
  }
}



// 礼物动画
.gift-animation {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
  pointer-events: none;
}

.gift-effect {
  padding: 16px 32px;
  background: linear-gradient(135deg, rgba(255, 215, 0, 0.9) 0%, rgba(255, 165, 0, 0.9) 100%);
  border-radius: 24px;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  animation: giftPop 2s ease-out forwards;
  backdrop-filter: blur(10px);
}

@keyframes giftPop {
  0% {
    opacity: 0;
    transform: scale(0.5);
  }
  20% {
    opacity: 1;
    transform: scale(1.1);
  }
  80% {
    opacity: 1;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(0.8);
  }
}
// 下一个直播按钮容器
.next-video-btn-wrapper {
  position: absolute;
  bottom: 12px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 50;
}

// 下一个直播按钮
.next-video-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 28px;
  background: linear-gradient(135deg, rgba(139, 92, 246, 0.9) 0%, rgba(168, 85, 247, 0.9) 100%);
  backdrop-filter: blur(10px);
  border: none;
  border-radius: 28px;
  color: #fff;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 16px rgba(139, 92, 246, 0.4);

  &:hover {
    background: linear-gradient(135deg, rgba(124, 58, 237, 1) 0%, rgba(147, 51, 234, 1) 100%);
    transform: scale(1.08);
    box-shadow: 0 4px 16px rgba(139, 92, 246, 0.4);
  }

  i {
    font-size: 16px;
  }

  span {
    font-size: 14px;
  }
}
</style>
